@if (!exercise.isHidden) {
  @if (paginationActivity.isSent) {
    <div
      class="pagination__item_sent rounded cursor-pointer"
      matTooltip="{{ 'f.pagination.locked' | translate }}"
      matTooltipClass="mat-tooltip"
      matTooltipPosition="below">
      <svg-icon class="pagination__item_sent--disabled" key="disabled-locked" size="md"></svg-icon>
    </div>
  } @else {
    <div class="flex items-center">
      @if (exercise.number - 1 === 0) {
        <div class="w-2.5"></div>
      }
      @switch (exercise.status) {
        @case (PageActivityStatus.SAVED) {
          <div
            class="pagination__item rounded cursor-pointer"
            matTooltip="{{ 'f.pagination.saved' | translate }}"
            matTooltipClass="mat-tooltip"
            matTooltipPosition="below">
            <svg-icon key="check-circle-filled" [ngClass]="completedStatusClass" size="md"></svg-icon>
          </div>
        }
        @case (PageActivityStatus.COMPLETED) {
          <div
            class="pagination__item rounded cursor-pointer"
            matTooltip="{{ 'f.pagination.completed' | translate }}"
            matTooltipClass="mat-tooltip"
            matTooltipPosition="below">
            <svg-icon key="circle-filled" [ngClass]="completedStatusClass" size="md"></svg-icon>
          </div>
        }
        @case (PageActivityStatus.INCOMPLETED) {
          <div
            class="pagination__item rounded cursor-pointer"
            matTooltip="{{ 'f.pagination.incompleted' | translate }}"
            matTooltipClass="mat-tooltip"
            matTooltipPosition="below">
            <svg-icon key="half-circle" [ngClass]="incompletedStatusClass" size="md"></svg-icon>
          </div>
        }
        @case (PageActivityStatus.TO_DO) {
          <div class="pagination__item rounded cursor-pointer">
            <svg-icon key="empty-circle" [ngClass]="toDoStatusClass" size="md"></svg-icon>
          </div>
        }
      }
      @if (exercise.number !== paginationActivity.exercises.length && !paginationActivity.isSent) {
        <div
          class="border h-px line {{ completedStatusClass }}"
          [ngClass]="{
            'border-solid': !exercise.isHidden,
            'border-dashed text-disabled': exercise.isHidden || paginationActivity.exercises[exercise.number].isHidden,
          }"></div>
      }
    </div>
  }
} @else {
  <div class="flex items-center" [ngClass]="{ pagination__item_sent: paginationActivity.isSent }">
    <div
      class="pagination__item rounded cursor-pointer"
      matTooltip="{{ 'f.pagination.disabled' | translate }}"
      matTooltipClass="mat-tooltip"
      matTooltipPosition="below">
      @if (exercise.number - 1 === 0 && !paginationActivity.isSent) {
        <div class="w-2.5"></div>
      }
      <svg-icon key="disable-circle" size="md"></svg-icon>
    </div>
    @if (exercise.number !== paginationActivity.exercises.length && !paginationActivity.isSent) {
      <div
        class="border h-px line {{ completedStatusClass }}"
        [ngClass]="{
          'border-solid': !exercise.isHidden,
          'border-dashed text-disabled': exercise.isHidden || paginationActivity.exercises[exercise.number].isHidden,
        }"></div>
    }
  </div>
}
